import { c as _c } from "react/compiler-runtime";
import { useContext, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import useSWR from 'swr';
import { APIList } from '../../../../../../../typings/API.interface';
import { APIWebhook } from '../../../../../../../typings/Webhook.interface';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import LINKS from '../../../../configs/links';
import Button from '../../../common/base/Button';
import Icon from '../../../common/base/Icon';
import Loading from '../../../common/base/Loading';
import Text from '../../../common/base/Text';
import CopyableField from '../../../common/CopyableField';
import { Div } from '../../../common/helpers/StyledUtils';
import { useToasts } from '../../../common/Toast';
import { GlobalContext } from '../../../contexts/GlobalContext';
const StyledEmptyView = styled.div`
  flex-grow: 1;
  max-width: 480px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const EventListEmptyView: React.FC<{
  webhooks: APIList<APIWebhook>;
}> = t0 => {
  const $ = _c(40);
  const {
    webhooks
  } = t0;
  const default_webhook = webhooks?.count > 0 && webhooks.models[0];
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const {
    addToast
  } = useToasts();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = APIMethodKeys.events.list({
      limit: 1
    });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== HookdeckAPI.events) {
    t2 = () => HookdeckAPI.events.list({
      limit: 1
    });
    $[1] = HookdeckAPI.events;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data: events
  } = useSWR(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = APIMethodKeys.events.list({
      limit: 1,
      cli_id: {
        any: true
      }
    });
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== HookdeckAPI.events) {
    t4 = () => HookdeckAPI.events.list({
      limit: 1,
      cli_id: {
        any: true
      }
    });
    $[4] = HookdeckAPI.events;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const {
    data: cli_events
  } = useSWR(t3, t4);
  let t5;
  if ($[6] !== HookdeckAPI.webhooks || $[7] !== addToast || $[8] !== default_webhook) {
    t5 = () => {
      setLoading(true);
      if (default_webhook) {
        HookdeckAPI.webhooks.test(default_webhook.id).then(() => {
          addToast("info", "Test event sent, hold on a second while it's processed!");
          setLoading(true);
        }).catch(() => setLoading(false));
      }
    };
    $[6] = HookdeckAPI.webhooks;
    $[7] = addToast;
    $[8] = default_webhook;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const onSendTestEvent = t5;
  if (!events || !cli_events || !webhooks) {
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <StyledEmptyView><Loading /></StyledEmptyView>;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    return t6;
  }
  if (default_webhook && cli_events.count === 0 && location.pathname === "/events/cli") {
    let t6;
    let t7;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        all: 7
      };
      t7 = {
        direction: "column",
        align: "center",
        justify: "center"
      };
      $[11] = t6;
      $[12] = t7;
    } else {
      t6 = $[11];
      t7 = $[12];
    }
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <Text bold={true} center={true} as="p" size="xl" m={{
        t: 4
      }}>Receive events on your local server</Text>;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    const t9 = events.count === 0 && "Once connected send a request to your Hookdeck URL.";
    let t10;
    if ($[14] !== t9) {
      t10 = <Text as="p" center={true}>Install the CLI to receive your events on your local server while developing or debugging your integration.{" "}{t9}</Text>;
      $[14] = t9;
      $[15] = t10;
    } else {
      t10 = $[15];
    }
    let t11;
    if ($[16] !== default_webhook || $[17] !== events.count) {
      t11 = events.count === 0 && <CopyableField value={default_webhook.source.url} />;
      $[16] = default_webhook;
      $[17] = events.count;
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    let t12;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <Button as="a" m={{
        y: 6
      }} target="_blank" href={LINKS.product_docs.cli}>Install</Button>;
      $[19] = t12;
    } else {
      t12 = $[19];
    }
    let t13;
    if ($[20] !== t10 || $[21] !== t11) {
      t13 = <StyledEmptyView><Div p={t6} flex={t7}>{t8}{t10}{t11}{t12}</Div></StyledEmptyView>;
      $[20] = t10;
      $[21] = t11;
      $[22] = t13;
    } else {
      t13 = $[22];
    }
    return t13;
  }
  if (default_webhook && events.count === 0 && cli_events.count === 0) {
    let t6;
    let t7;
    let t8;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        all: 7
      };
      t7 = {
        direction: "column",
        align: "center",
        justify: "center"
      };
      t8 = <Icon icon="loading" muted={true} />;
      $[23] = t6;
      $[24] = t7;
      $[25] = t8;
    } else {
      t6 = $[23];
      t7 = $[24];
      t8 = $[25];
    }
    let t9;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <Text bold={true} as="p" size="xl" m={{
        t: 4
      }}>Waiting for an event</Text>;
      $[26] = t9;
    } else {
      t9 = $[26];
    }
    let t10;
    if ($[27] !== default_webhook.source.name) {
      t10 = <Text center={true} as="p">Update your source <strong>{default_webhook.source.name}</strong> with the provided Hookdeck URL.</Text>;
      $[27] = default_webhook.source.name;
      $[28] = t10;
    } else {
      t10 = $[28];
    }
    let t11;
    if ($[29] !== default_webhook.source.url) {
      t11 = <CopyableField mono={true} value={default_webhook.source.url} />;
      $[29] = default_webhook.source.url;
      $[30] = t11;
    } else {
      t11 = $[30];
    }
    let t12;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <Text size="s" muted={true} m={{
        y: 4
      }}>– or –</Text>;
      $[31] = t12;
    } else {
      t12 = $[31];
    }
    let t13;
    if ($[32] !== loading || $[33] !== onSendTestEvent) {
      t13 = <Button ghost={true} primary={true} disabled={loading} onClick={onSendTestEvent}>Send a test request</Button>;
      $[32] = loading;
      $[33] = onSendTestEvent;
      $[34] = t13;
    } else {
      t13 = $[34];
    }
    let t14;
    if ($[35] !== t10 || $[36] !== t11 || $[37] !== t13) {
      t14 = <StyledEmptyView><Div p={t6} flex={t7}>{t8}{t9}{t10}{t11}{t12}{t13}</Div></StyledEmptyView>;
      $[35] = t10;
      $[36] = t11;
      $[37] = t13;
      $[38] = t14;
    } else {
      t14 = $[38];
    }
    return t14;
  }
  let t6;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <StyledEmptyView><Div p={{
        y: 24
      }} flex={{
        direction: "column",
        align: "center",
        justify: "center"
      }}><Text as="p" semi={true} muted={true} m={0}>No events match those filters.</Text></Div></StyledEmptyView>;
    $[39] = t6;
  } else {
    t6 = $[39];
  }
  return t6;
};
export default EventListEmptyView;